import ethereum from '../../../../assets/landing/ethereum.png';
import mongodb from '../../../../assets/landing/mongodb.png';
import metamask from '../../../../assets/landing/metamask.png';
import ipfs from '../../../../assets/landing/ipfs.png';
import '../../../../styles/LandingStyles/TechStack.scss';
export const techStackImages=[
    {
        id:1,
        url:ethereum
    },
    {
        id:2,
        url:metamask
    },
    {
        id:3,
        url:ipfs
    },
    {
        id:4,
        url:mongodb
    }
]